import { Progress } from 'antd';

const ExportVideoProgressBar = ({ progress }) => {
  return (
    <div>
      <Progress
        strokeColor={'#4AA462'}
        size={'small'}
        percent={progress}
        type={'line'}
      />
    </div>
  );
};

export default ExportVideoProgressBar;
